// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2tEzM","header":"PatientQuestionnaire_header__1QVgx","info":"PatientQuestionnaire_info__3Lb-V"};